// Ponto unico de import do Tiptap 2. Fica em .js de proposito: o verificador
// de TypeScript do projeto (TS 4.1) le os .vue e nao entende as declaracoes de
// tipo do Tiptap/ProseMirror (sintaxe do TS 4.5+); arquivos .js ele nao segue.
import { Editor, EditorContent } from "@tiptap/vue-2";
import StarterKit from "@tiptap/starter-kit";
import Underline from "@tiptap/extension-underline";
import TextAlign from "@tiptap/extension-text-align";
import TextStyle from "@tiptap/extension-text-style";
import FontFamily from "@tiptap/extension-font-family";
import Color from "@tiptap/extension-color";
import Highlight from "@tiptap/extension-highlight";
import Subscript from "@tiptap/extension-subscript";
import Superscript from "@tiptap/extension-superscript";
import TableRow from "@tiptap/extension-table-row";
import Placeholder from "@tiptap/extension-placeholder";
import CharacterCount from "@tiptap/extension-character-count";
import { FontSize, ParagraphFormat, CharacterFormat } from "./extensions/formatting";
import { HouseQuote, PageBreak, StyledTable, StyledTableCell, StyledTableHeader, DocumentLink, DocumentImage } from "./extensions/nodes";
import { DocumentSearch } from "./extensions/search";
import { Footnote, FootnoteList } from "./extensions/footnotes";
import { DocumentStyles } from "./extensions/styles";

export { EditorContent };

// Cria o editor com o conjunto de extensoes do documento.
export function createDocumentEditor({ content, editable, placeholder, editorProps, ...events }) {
    return new Editor({
        content,
        editable,
        extensions: [
            StarterKit.configure({ blockquote: false, codeBlock: false, code: false }),
            HouseQuote,
            Underline,
            TextStyle,
            FontFamily,
            FontSize,
            Color,
            Highlight.configure({ multicolor: true }),
            Subscript,
            Superscript,
            TextAlign.configure({ types: ["heading", "paragraph"], defaultAlignment: "justify" }),
            ParagraphFormat,
            CharacterFormat,
            DocumentStyles,
            StyledTable,
            TableRow,
            StyledTableHeader,
            StyledTableCell,
            DocumentLink,
            DocumentImage,
            PageBreak,
            Footnote,
            FootnoteList,
            DocumentSearch,
            Placeholder.configure({ placeholder }),
            CharacterCount,
        ],
        editorProps,
        ...events,
    });
}
